import * as React from 'react';
import { Redirect } from 'react-router-dom';
import {
  CipGenerationWrapper,
  Content,
  BoxWrapper
} from './styled';

import { HeaderFeature } from '@app/src/commons/header';
import { FormFeature } from './generateForm';
import { SidebarFeature } from '@app/src/commons/sidebar';
import { useAuthorization } from '@app/src/utils/validations';
import { getSettings } from '@app/src/configuration/config.service';


export const CipGeneration = ({ history }) => {

  const isValid = useAuthorization();
  
  if (!isValid) {
    return <Redirect to="/" />;
  }
  return (
      <>
        <CipGenerationWrapper data-test="generateBlockPage">
          <SidebarFeature history={history} />
          <Content>
            <BoxWrapper>
              <HeaderFeature
                data-test="subTitle"
                subTitle="Generación de CIP"
              />
              <FormFeature url={getSettings().API_CIPS} />
            </BoxWrapper>
          </Content>
        </CipGenerationWrapper>
      </>
  );

};
